import { css } from '@emotion/react';

import { ThemeType } from '@/modules/common';

type BubbleProps = {
  theme: ThemeType;
  isLoadingMessage?: boolean;
  isSingleLine?: boolean;
  isUserMessage?: boolean;
};

export const bubbleStyles = ({ theme, isUserMessage, isSingleLine, isLoadingMessage }: BubbleProps) => css`
  min-width: ${isLoadingMessage ? 'none' : '206px'};
  max-width: 280px;
  padding: ${isSingleLine ? '10px' : '15px'} 15px;
  border: none;
  border-radius: 8px;

  ${isUserMessage ? theme.bubble.user : theme.bubble.ml};

  @media (${theme.mediaMobile}) {
    ${isUserMessage ? theme.bubble.user.mobile : theme.bubble.ml.mobile};
  }
`;
